var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87041 0.440918C1.26457 0.440918 0.773438 0.932046 0.773438 1.53789V14.7985C0.773438 15.4043 1.26457 15.8954 1.87041 15.8954H15.131C15.7369 15.8954 16.228 15.4043 16.228 14.7985V1.53789C16.228 0.932047 15.7369 0.440918 15.131 0.440918H1.87041ZM4.24227 5.24033C4.98271 5.24033 5.58295 4.64009 5.58295 3.89966C5.58295 3.15922 4.98271 2.55898 4.24227 2.55898C3.50184 2.55898 2.90159 3.15922 2.90159 3.89966C2.90159 4.64009 3.50184 5.24033 4.24227 5.24033ZM6.81079 6.23113H9.03272V7.24901C9.03272 7.24901 9.63567 6.04311 11.2762 6.04311C12.7397 6.04311 13.952 6.76403 13.952 8.96147V13.5952H11.6494V9.52296C11.6494 8.22668 10.9573 8.08411 10.43 8.08411C9.33556 8.08411 9.14819 9.02813 9.14819 9.69205V13.5952H6.81079V6.23113ZM5.41098 6.23114H3.07357V13.5953H5.41098V6.23114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.84bd6ac44a1b7fbc1ae86383bf906202.svg";
export { ForwardRef as ReactComponent };